// extracted by mini-css-extract-plugin
module.exports = {"container":"TenderSelectLoader_container__OUcg1"};